__turbopack_context__.v({
  "nudge": "planner-fab-module__AsAueq__nudge",
  "ping": "planner-fab-module__AsAueq__ping",
  "pingLate": "planner-fab-module__AsAueq__pingLate",
});
